module.exports = __webpack_public_path__ + "static/img/dsp.c6bc864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/dsp.png
// module id = APPR
// module chunks = 1